/* UGC Video Strip — Lightbox interaction
   Vanilla JS, no external dependencies */

(function () {
  'use strict';

  var lightbox = document.getElementById('ugc-lightbox');
  if (!lightbox) return;

  var ratioBox = lightbox.querySelector('.ugc-lightbox__ratio');
  var iframe   = lightbox.querySelector('.ugc-lightbox__iframe');
  var video    = lightbox.querySelector('.ugc-lightbox__video');
  var closeBtn = lightbox.querySelector('.ugc-lightbox__close');

  function isDirectVideo(url) {
    return /\.(mp4|webm|ogg|mov)(\?|$)/i.test(url) || url.indexOf('cdn.shopify.com/videos') !== -1;
  }

  function openLightbox(embedUrl, platform, orientation) {
    ratioBox.setAttribute('data-platform', platform || 'youtube');
    ratioBox.setAttribute('data-orientation', orientation || 'portrait');

    if (isDirectVideo(embedUrl)) {
      iframe.style.display = 'none';
      iframe.src = '';
      video.style.display = 'block';
      video.src = embedUrl;
      video.play();
    } else {
      video.style.display = 'none';
      video.pause();
      video.src = '';
      iframe.style.display = 'block';
      iframe.src = embedUrl;
    }

    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    closeBtn.focus();
    document.body.style.overflow = 'hidden';
    trapFocus(lightbox);
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    iframe.src = '';
    video.pause();
    video.src = '';
    document.body.style.overflow = '';
    releaseFocus();
  }

  /* ── Focus trap ── */
  var focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var firstFocusable, lastFocusable;

  function trapFocus(el) {
    var focusable = el.querySelectorAll(focusableSelectors);
    firstFocusable = focusable[0];
    lastFocusable  = focusable[focusable.length - 1];
    document.addEventListener('keydown', handleFocusTrap);
  }

  function releaseFocus() {
    document.removeEventListener('keydown', handleFocusTrap);
  }

  function handleFocusTrap(e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      }
    } else {
      if (document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  }

  /* ── Close triggers ── */
  closeBtn.addEventListener('click', closeLightbox);

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
      closeLightbox();
    }
  });

  /* ── Card click listeners ── */
  var cards = document.querySelectorAll('.ugc-video-card');

  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      var embedUrl    = card.getAttribute('data-embed-url');
      var platform    = card.getAttribute('data-platform');
      var orientation = card.getAttribute('data-orientation');
      if (!embedUrl) return;
      openLightbox(embedUrl, platform, orientation);
    });

    /* Keyboard: Enter / Space activates card */
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        card.click();
      }
    });
  });
}());
